<template>
  <b-modal id="bv-modal-reward-rate">
    <template #modal-header>
      <h4>{{ $t("update-reward-rate") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-reward-rate')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-form @submit.prevent="add">
      <div class="text-center">
        <div class="mb-4">
          <span>{{ $t("edit-reward-rate") }}</span>
          <b-form-group class="row justify-content-center">
            <b-button-group>
              <b-button
                :disabled="data.amount <= 0 ? true : false"
                @click="data.amount = parseInt(data.amount) - parseInt(1)"
                variant="primary"
                class="mr-1"
                ><i class="ni ni-fat-delete"></i
              ></b-button>
              <b-form-input
                class="text-center"
                type="number"
                min="1"
                v-model="data.amount"
                :placeholder="$t('update-reward-rate')"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :data-vv-as="$t('update-reward-rate')"
                name="total_amount"
                autocomplete="ÑÖcompletes"
              ></b-form-input>
              <b-button
                @click="data.amount = parseInt(data.amount) + parseInt(1)"
                variant="primary"
                class="ml-1"
                ><i class="ni ni-fat-add"></i
              ></b-button>
            </b-button-group>
            <span
              class="text-danger text-sm"
              v-show="errors.has('total_amount')"
              ><small>{{ errors.first("total_amount") }}</small></span
            >
          </b-form-group>
        </div>
        <div>
          <span>{{ $t("update-payment-week") }}</span>
          <b-form-group class="row justify-content-center">
            <b-button-group>
              <b-button
                :disabled="data.payments_per_week <= 0 ? true : false"
                @click="data.payments_per_week = parseInt(data.payments_per_week) - parseInt(1)"
                variant="primary"
                class="mr-1"
                ><i class="ni ni-fat-delete"></i
              ></b-button>
              <b-form-input
                class="text-center"
                type="number"
                min="1"
                v-model="data.payments_per_week"
                :placeholder="$t('update-reward-rate')"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :data-vv-as="$t('update-reward-rate')"
                name="total_amount"
                autocomplete="ÑÖcompletes"
              ></b-form-input>
              <b-button
                @click="data.payments_per_week = parseInt(data.payments_per_week) + parseInt(1)"
                variant="primary"
                class="ml-1"
                ><i class="ni ni-fat-add"></i
              ></b-button>
            </b-button-group>
            <span
              class="text-danger text-sm"
              v-show="errors.has('total_amount')"
              ><small>{{ errors.first("total_amount") }}</small></span
            >
          </b-form-group>
        </div>
      </div>
    </b-form>
    <template #modal-footer>
      <b-button ype="submit" size="sm" variant="primary" @click="add">
        {{ $t("save") }}
      </b-button>
      <b-button
        type="reset"
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-reward-rate')"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      data: {
        company_id: this.$route.params.id,
        amount: 0,
        payments_per_week: 0,
      },
    };
  },
  methods: {
    ...mapActions({
      configurationPayments: "company/configurationPayments",
    }),
    show(item) {
      if (item) {
        this.data.amount = item.payment_for_visits;
        this.data.payments_per_week = item.payments_per_week;
      }
      this.$bvModal.show("bv-modal-reward-rate");
    },

    async add() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        const res = await this.configurationPayments(this.data);
        this.$bvModal.hide("bv-modal-reward-rate");
        this.$toast.success(res.message, {
          position: "top-right",
        });
      }
    },
  },
};
</script>

<style></style>
